<template>
  <div
    class="issues-list-item-container"
    :style="mainColorBorderStyle">
    <div class="issues-list-item row">
      <div class="issues-list-item__section col-md-2">
        <div class="issues-list-item__section-title small">
          ISSUE TYPE
        </div>
        <div>
          {{ getCategoryName(issue) }}
        </div>
        <div class="issues-list-item__section-title small mt-2">
          ISSUE CODE
        </div>
        <div>
          {{ issue.errorCode }}
        </div>
      </div>
      <!-- <div class="issues-list-item__section col-md-2">
      </div> -->
      <div class="issues-list-item__section col-md-6">
        <div class="issues-list-item__section-title small">
          DESCRIPTION
        </div>
        {{ issue.description || 'Unknown error without description in documents' }}
      </div>
      <div class="issues-list-item__section col-md-2">
        <div class="issues-list-item__section-title small">
          FOUND
        </div>
        <h4 class="issues-list-item__section-found mt-2">
          {{ issue.count }}
        </h4>
      </div>
      <div class="issues-list-item__section col-md-2">
        <div class="issues-list-item__section-title small">
          RATE
        </div>
        <h4 class="issues-list-item__section-found mt-2">
          {{ issue.percentageErrorFromAllErrorCount.toFixed(2) }}%
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import getIssuesColor from '@/utils/colorGeneratorUtils';
// import getIssuesColor from '../utils/colorGeneratorUtils';

export default {
  mixins: [getIssuesColor],
  props: ['issue'],
  computed: {
    errorKey() {
      return _.get(this.issue, 'errorCategory.key', null);
    },
    issueColor() {
      return this.getIssuesColor(this.errorKey);
    },
    mainColorBorderStyle() {
      return {
        borderLeft: `15px solid ${this.issueColor.mainColor}`,
      };
    },
    mainColorStyle() {
      return {
        color: this.issueColor.mainColor,
      };
    },
  },
  methods: {
    getCategoryName(issue) {
      return _.get(issue, 'errorCategory.name', 'Unknown');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.issues-list-item__section {
  .issues-list-item__section-title {
    color: $gray-500;
    margin-bottom: $spacer * .25;
  }
}

.issues-list-item-container {
  margin: $spacer * .5;
  padding: $spacer;
  border: 1px solid $gray-200;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  align-items: center;
}

@media (max-width: 575.98px) {
  .issues-list-item__section {
    margin-top: $spacer;
  }
  .issues-list-item__section:first-child {
    margin-top: 0;
  }
}
</style>
